import { render, staticRenderFns } from "./PaymentSetupView.vue?vue&type=template&id=f54d04cc&scoped=true"
import script from "./PaymentSetupView.vue?vue&type=script&lang=js"
export * from "./PaymentSetupView.vue?vue&type=script&lang=js"
import style0 from "./PaymentSetupView.vue?vue&type=style&index=0&id=f54d04cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54d04cc",
  null
  
)

export default component.exports